<template>
    <div>
        <!-- COMPONENTE QUE GERA O LOADING EFECT -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- FIM COMPONENTE QUE GERA O LOADING EFECT -->

        <!--==== CONTAINER VENDAS ====-->
        <div class="flex flex-col">
            <div class="flex-1 bg-white shadow-xl">
                <!--====== COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->
                <div class="header-table">
                    <div class="combo_box_container">
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date"
                            rounded transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date" label="Seleciona a data inicial" readonly v-bind="attrs"
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                                <v-btn text color="primary" @click="salvarData()"> OK </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                    <div class="tpaCombox">
                        <v-combobox v-model="formaSelected" label="Forma de pagamento" item-value="id" item-text="value"
                            :items="formasPagamentos" return-object @change="filtrarEmolumento()" rounded>
                        </v-combobox>
                    </div>
                </div>
                <!--====== FIM COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->
            </div>
        </div>
        <!--===== TABELA QUE LISTA OS EMOLUMENTOS ======-->
        <v-data-table :headers="headers" :items="vendasFiltradas" class="elevation-3">
            <template v-slot:item.index="{ item }">
                <span> {{ vendasFiltradas.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:item.subTotal="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.subTotal) }}</span>
            </template>
            <template v-slot:item.valorAPagar="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.valorAPagar) }}</span>
            </template>
            <template v-slot:item.valorPago="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.valorPago) }}</span>
            </template>
            <template v-slot:item.desconto="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.desconto) }}</span>
            </template>
            <template v-slot:item.troco="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.troco) }}</span>
            </template>
        </v-data-table>
        <!--===== TABELA QUE LISTA OS EMOLUMENTOS ======-->

        <!--==== CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
        <div class="totaisContainer" v-if="vendasFiltradas.length">
            <div>
                <span class="align-totais">Total Pago</span>
                <span class="text-bold totais-font-size">
                    {{ utilitarios.IntegerToMoneyValueFatura(totaisObject.total) }}</span>
            </div>
        </div>
        <!--====  FIM CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
    </div>
</template>

<script>
import _axios from '../../plugins/axios';
import utilitarios from '../../plugins/utilitarios';
const ls = require('local-storage');
import Swal from 'sweetalert2';
export default {
    data: () => ({
        utilitarios: utilitarios,
        vendas: [],
        vendasFiltradas: [],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        headers: [
            { text: "#", value: "index" },
            { text: "Factura", value: "numeroDocumento" },
            { text: "Cliente", value: "cliente" },
            { text: "Emolumentos", value: "produto" },
            { text: "Subtotal", value: "subTotal" },
            { text: "Valor a pagar", value: "valorAPagar" },
            { text: "Valor Pago", value: "valorPago" },
            { text: "Desconto", value: "desconto" },
            { text: "Troco", value: "troco" },
            { text: "F. Pagamento", value: "descricao" },
        ],
        formasPagamentos: [],
        formaSelected: null
    }),

    props: {
        funcionario: null,
    },

    computed: {
        totaisObject() {
            let totais = { total: 0 }
            this.vendasFiltradas.forEach(element => {
                totais.total += (element.valorPago === 'N/A' || element.valorPago === null || element.valorPago === undefined) ? 0 : utilitarios.MoneyValueToInteger(element.valorPago)
            });
            return totais
        }
    },

    created() {
        this.pesquisarVendas();
    },

    methods: {
        async pesquisarVendas() {
            try {
                this.overlay = true;
                this.vendas = await _axios.get(`/listarRegistroFacturas/${this.funcionario.pkUsuario}/${this.date}`).then((res) => res.data);

                const idSet = new Set();
                this.formasPagamentos = [{ id: 0, value: 'Todos' }];
                this.vendas.forEach(item => {
                    if (!idSet.has(item.pkforma_pagamento)) {
                        idSet.add(item.pkforma_pagamento);
                        this.formasPagamentos.push({ id: item.pkforma_pagamento, value: item.descricao });
                    }
                });
                this.formaSelected = { id: 0, value: 'Todos' };
                this.filtrarEmolumento();
            } catch (error) {
                Swal.fire('Error', 'Ocorreu um erro durante a listagem dos pagamentos!', 'error');
            } finally {
                this.overlay = false;
            }
        },

        filtrarEmolumento() {
            if (this.formaSelected.id == 0) {
                this.vendasFiltradas = this.vendas;
            } else {
                this.vendasFiltradas = this.vendas.filter((v) => v.pkforma_pagamento == this.formaSelected.id)
            }
        },

        salvarData() {
            this.$refs.menu.save(this.date)
            this.pesquisarVendas()
        },

        data_hora() {
            let data = new Date()
            return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
        }
    }
};
</script>

<style scoped>
.combo_box_container {
    display: flex;
    justify-content: space-between;
    width: 250px;
}

.header-table {
    display: flex;
    justify-content: space-between;
    padding: 5px 50px 5px 5px;
}

.table_data {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border: 1px solid #e2e8f0;
    font-size: 0.75rem;
}

.table_head {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border: 1px solid #e2e8f0;
    font-size: 0.75rem;
}

.bg-gray100 {
    background-color: #f3f4f6;
}

.totaisContainer {
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    width: 100%;
    padding: 10px;
    background-color: #fff;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-bottom: 10px;
}

.align-totais {
    margin-left: 15px;
}

.text-bold {
    font-weight: bold;
}

.totais-font-size {
    font-size: 17px;
}

.semPagamentos {
    font-weight: bold;
    text-align: center;
    height: 30px;
    font-size: 13px;
}

.semPagamentos p {
    line-height: 30px;
}

.table-full {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border: 1px solid #e2e8f0;
    text-align: center;
}
</style>